var _style, _rect, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _circle, _path7, _polygon2, _path8, _path9, _path10, _path11, _polygon3, _path12, _path13, _ellipse, _polygon4, _path14, _polygon5, _path15, _polygon6, _path16, _polygon7, _path17, _polygon8, _path18, _polygon9, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleteDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b3347a10-18dd-4c71-91c3-38a98340ba03",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 963.5 774.4",
    style: {
      enableBackground: "new 0 0 963.5 774.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F3D56;}\n\t.st1{fill:#FFB8B8;}\n\t.st2{fill:#CFCCE0;}\n\t.st3{fill:#2F2E41;}\n\t.st4{fill:#575A89;}\n\t.st5{fill:#797BF2;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "project_completed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 719.5,
    className: "st0",
    width: 963.5,
    height: 2.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M604.5,335.8c0,0-43.2,34-21.6,41.7s35.5-27.8,35.5-27.8L604.5,335.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M606.1,323.5l-9.3,15.4c0,0,15.4,0,18.5,23.2l12.3-15.4L606.1,323.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "811.3,675.4 812.9,721.7 794.4,732.5 786.7,727.9 788.2,675.4 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M701.8,663l3.1,49.4l-43.2,18.5l3.1-26.2c0,0,12.3-20.1,9.3-41.7L701.8,663z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M768.1,291c0,0,24.7,64.8,29.3,105s12.3,146.6,12.3,146.6L825.2,680l-43.2,6.2l-18.5-138.9l-41.7-137.4 l-9.3,137.4l-7.7,125l-40.1,1.5l-3.1-129.7l-17-165.2l9.3-78.7L768.1,291z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M791.3,724.8c0,0,2.5-25.9,21.3-11.4l3.4-2.5l15.4,34c0,0,18.5,26.2-13.9,29.3s-29.3-29.3-29.3-29.3l-3.1-13.9 l1.5-9.1L791.3,724.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M701.8,693.9c7.7,4.4,12.5,12.7,12.3,21.6c0,15.4-1.5,17-1.5,17l-23.2,6.2c0,0-15.4-1.5-24.7,7.7 s-55.6,15.4-55.6,3.1s38.6-32.4,38.6-32.4s11.5-19.4,19.6-17.4s11.2,5,11.2,6.6s-4.6,12.3-4.6,12.3S700.2,712.4,701.8,693.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 698.7,
    cy: 62.6,
    r: 38.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M727.2,72.6l17,38.6l-46.3,66.4c0,0-3.1-72.5-12.3-84.9S727.2,72.6,727.2,72.6z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "705.6,152.9 713.3,132.8 719.5,134.4 727.2,128.2 738,94.3 753.5,105.1 773.5,307.3 648.5,310.3  665.5,169.9 680.9,129.8 692.1,115 699.4,137.5 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M741.1,239.3l4.7-139.6c0,0,9.2,0.7,12.3,5.3s54,13.9,54,13.9l-9.3,143.5c0,0,38.6,114.2,24.7,120.4 s-38.6,4.6-38.6,4.6L741.1,239.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M666.3,221.6l16.4-94.1l-36.4,24.6l9.3,67.9l-7.7,46.3c0,0-29.3,128.1-20.1,132.7s20.1,0,20.1,0l18.5-129.7 V221.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M657,149.1l-10.8,3.1l-4.6,61.7l-7.7,54l-37,66.4c0,0,18.5-12.3,26.2,23.2l40.8-71L657,149.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M777.4,323.5c0,0-43.2,34-21.6,41.7s35.5-27.8,35.5-27.8L777.4,323.5z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "803.6,340.4 789.7,357.4 771.2,325 778.9,311.1 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M800.5,124.4l12.3-6.2c0,0,9.3,12.3,10.8,23.2s9.3,24.7,9.3,32.4s21.6,80.3,21.6,80.3l-49.4,100.3 c0,0-10.8-37-34-40.1l38.6-54l-21.6-38.6L800.5,124.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M731,25.9l7.3-2.9c0,0-15.2-16.8-36.4-15.3l6-6.6c0,0-14.6-5.8-27.8,9.5c-7,8-15,17.5-20,28.1h-7.8l3.3,7.2 L644.1,53l11.7-1.3c-0.7,3.9-0.8,7.9-0.3,11.9c0.5,4,2.5,7.6,5.6,10.1l0,0c0,0,9-18.7,9-21.6v7.3c0,0,7.3-6.6,7.3-10.9l4,5.1l2-8 l24.5,8l-4-6.6l15.2,2.2l-6-8c0,0,17.2,9.5,17.9,17.5c0.7,8,5.7,15.6,5.7,15.6S750.2,36.8,731,25.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 730.3,
    cy: 56.4,
    rx: 4.3,
    ry: 5.4
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "178.6,318.1 45.4,318.1 45.4,280.8 114.9,280.8 "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,313v109.1h432.7V313H45z M213.7,403.8H73.2v-15.4h140.6V403.8z M449.5,375.2H73.2v-15.4h376.3V375.2z  M449.5,346.7H73.2v-15.4h376.3V346.7z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "178.6,141.7 45.4,141.7 45.4,104.3 114.9,104.3 "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,138.8v109.1h432.7V138.8H45z M213.7,229.5H73.2v-15.4h140.6V229.5z M295,201H73.2v-15.4H295L295,201z  M449.5,172.4H73.2v-15.4h376.3V172.4z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "178.6,490.9 45.4,490.9 45.4,453.6 114.9,453.6 "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,483.6v109.1h432.7V483.6H45z M295,574.3H73.2V559H295L295,574.3z M295,545.8H73.2v-15.4H295L295,545.8z  M449.5,517.2H73.2v-15.4h376.3V517.2z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "600.3,223.7 538.8,223.7 538.8,162.2 580.5,162.2 580.5,163.6 540.3,163.6 540.3,222.2 598.8,222.2  598.8,192.9 600.3,192.9 "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M569.2,207.6c-1.4-4.2-19.2-18.5-8.3-20.9l9,11.9l41.2-41.2l4.1,4.1L569.2,207.6z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "600.3,397.9 538.8,397.9 538.8,336.4 580.5,336.4 580.5,337.9 540.3,337.9 540.3,396.5 598.8,396.5  598.8,367.2 600.3,367.2 "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M569.2,381.9c-1.4-4.2-19.2-18.5-8.3-20.9l9,11.9l41.2-41.2l4.1,4.1L569.2,381.9z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "600.3,571.4 538.8,571.4 538.8,509.9 580.5,509.9 580.5,511.4 540.3,511.4 540.3,570 598.8,570  598.8,540.7 600.3,540.7 "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M569.2,555.4c-1.4-4.2-19.2-18.5-8.3-20.9l9,11.9l41.2-41.2l4.1,4.1L569.2,555.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteDark);
export default __webpack_public_path__ + "static/media/complete-dark.4a14254f6f31629cbc04062aad53042d.svg";
export { ForwardRef as ReactComponent };